export default "__VITE_ASSET__Cvi7bMV$__"